import React, { useEffect } from "react";
import Layout from "../components/Layout/Layout";
import ReactPaginate from "react-paginate";
import { UserImageContext } from "../context/UserImageContext";
import {Image,Persona,Button,Spinner,Dialog,DialogSurface,DialogTitle,DialogContent,DialogTrigger,DialogBody} from "@fluentui/react-components";
import CustomIcon from "../components/Icons/CustomIcon";
import GPlogo from "../images/gpInteligence.svg";
import "./UserImages.css";

const UserImages = () => {
  const {
    getSavedImages,
    savedImages,
    loading,
    totalSavedImages,
    currentSavedImages,
    postsPerPage,
    currentPage,
    paginate,
  } = React.useContext(UserImageContext);
  const [open, setOpen] = React.useState(false);
  const [contenidoDialog, setcontenidoDialog] = React.useState({});

  useEffect(() => {
    getSavedImages(currentPage);
  }, [currentPage]);

  return (
    <>
      <Layout>
        {loading ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <Spinner color="gray" />
          </div>
        ) : (
          <div
            className="gallery-container"
            style={{
              paddingTop: "20px",
              paddingBottom: "20px",
            }}
          >
            {savedImages.length > 0 ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  marginRight:'20px'
                }}
              >
                <div className="blog-container">
                  {currentSavedImages.map((image) => (
                    <div className="blog-post" key={image.uri}>
                      <img
                        className="cover-img"
                        src={image.uri}
                        alt=""
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setOpen(true);
                          setcontenidoDialog({
                            image: image.uri,
                            createdBy: image.createdBy.name,
                            prompt: image.prompt,
                            createdDate: image.created,
                          });
                        }}
                      />
                      <div className="card-details">
                        <Button
                          appearance="subtle"
                          icon={<CustomIcon type="preview" />}
                          style={{
                            marginRight: "10px",
                          }}
                          size="large"
                          onClick={() => {
                            setOpen(true);
                            setcontenidoDialog({
                              image: image.uri,
                              createdBy: image.createdBy.name,
                              prompt: image.prompt,
                              createdDate: image.created,
                            });
                          }}
                        />
                      </div>
                    </div>
                  ))}
                </div>
                <div>
                  <ReactPaginate
                    onPageChange={paginate}
                    pageCount={Math.ceil(totalSavedImages / postsPerPage)}
                    previousLabel={" ← Prev"}
                    nextLabel={"Sig → "}
                    containerClassName={"pagination"}
                    pageLinkClassName={"page-number"}
                    previousLinkClassName={"page-number"}
                    nextLinkClassName={"page-number"}
                    activeLinkClassName={"active"}
                    forcePage={currentPage - 1}
                  />
                </div>
              </div>
            ) : (
              <div>No hay imágenes guardadas en la galería</div>
            )}
          </div>
        )}

        <Dialog
          open={open}
          onOpenChange={(event, data) => {
            setOpen(data.open);
          }}
          style={{ width: "80%" }}
        >
          <DialogSurface
            aria-describedby={undefined}
            className="dialog-container"
            style={{
              backgroundColor: "rgba(0,0,0,0.8)",
              maxWidth: "100%",
              marginTop: "55px",
              width: "95%",
              height: "100%",
            }}
          >
            <DialogBody>
              <DialogTitle
                action={
                  <DialogTrigger action="close">
                    <Button
                      appearance="subtle"
                      aria-label="Cerrar"
                      icon={<CustomIcon type="close" />}
                    />
                  </DialogTrigger>
                }
              ></DialogTitle>
              <DialogContent>
                <div
                  style={{
                    display: "grid",
                    overflow: "hidden",
                    gridTemplateRows: "auto auto 60px",
                  }}
                >
                  <div
                    style={{
                      textAlign: "center",
                      backgroundColor: "rgba(0,0,0,0.10)",
                      position: "relative",
                    }}
                  >
                    <img
                      src={GPlogo}
                      alt="gpInteligence"
                      className="gpInteligence"
                    />
                    <Image
                      fit="cover"
                      src={contenidoDialog.image}
                      className="imagedialog"
                    />
                  </div>
                </div>
              </DialogContent>
            </DialogBody>
          </DialogSurface>
        </Dialog>
      </Layout>
    </>
  );
};

export default UserImages;
